import React from "react";

import Box from "@mui/material/Box";

const ChartLabel = ({ text, color }) => {
	return (
		<Box
			sx={{
				background: color,
				color: "#fff",
				px: 2,
				width: "200px",
				textAlign: "center",
				ml: "16px",
			}}
		>
			{text}
		</Box>
	);
};

export default ChartLabel;
